import { Link, NavLink } from "react-router-dom";
import { useCart } from "../lib/cart-context";
import { DataSciLogo } from "./DataSciLogo";

export function Header() {
  const { items } = useCart();
  const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <header className="site-header">
      <div className="site-header__brand-strip">
        <div className="container site-header__bar">
          <Link to="/" className="brand" aria-label="DataSci — página inicial">
            <DataSciLogo />
          </Link>
        </div>
      </div>
      <div className="site-header__menu-strip">
        <nav aria-label="Navegação principal" className="container site-nav">
          <NavLink to="/" end>Institucional</NavLink>
          <NavLink to="/catalogo">Catálogo</NavLink>
          <NavLink to="/resgatar">Resgatar código</NavLink>
          <NavLink to="/minha-biblioteca">Minha biblioteca</NavLink>
          <NavLink to="/login" className="site-nav__login">Entrar</NavLink>
          <Link to="/carrinho" className="cart-badge" aria-label={`Carrinho, ${itemCount} itens`}>
            Carrinho · {itemCount}
          </Link>
        </nav>
      </div>
    </header>
  );
}
